import { getCustomerIdEndpoint } from '@cp-mx/common';
import { getSimpleDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from '../../cp-xhr';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';

const { reducer, fetchData } = getSimpleDataFetchSlice<string, DefaultBusinessMarketApiErrorCode>({
    dataName: 'customer',
    fetchCallback() {
        return CpDataApi.get(getCustomerIdEndpoint()).then(response => response.data);
    },
});

export default reducer;
export const fecthCustomer = fetchData;
